export type PaymentMethodType = 'CASH' | 'CARD' | 'DELIVERY' | 'TRANSFER' | 'MERCADOPAGO';

const PaymentConfigEnum = {
  CASH: 'cash',
  CARD: 'card',
  DELIVERY: 'delivery',
  TRANSFER: 'transfer'
};

const MercadoPagoLabels = {
  MERCADOPAGO: 'mercadopago'
}

Object.freeze(PaymentConfigEnum);
const MercadoPagoEnum = Object.freeze(MercadoPagoLabels);

const ExtendedPaymentConfigEnum = Object.freeze({
  ...PaymentConfigEnum,
  ...MercadoPagoLabels
});
export { MercadoPagoEnum, ExtendedPaymentConfigEnum };
export default PaymentConfigEnum;
